"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  unidentified: {
    id: "tooltip.item.unidentified",
    defaultMessage: "Unidentified",
    description: "Unidentified"
  },
  untradeable: {
    id: "tooltip.item.untradeable",
    defaultMessage: "Untradeable",
    description: "Untradeable"
  },
  questReward: {
    id: "tooltip.item.questReward",
    defaultMessage: "Quest Reward",
    description: "Quest Reward"
  },
  "price-prefix": {
    id: "tooltip.item.price.prefix",
    defaultMessage: "Price:",
    description: "Price:"
  }
});

exports.default = _default;